import React from 'react';
import {useTranslation} from 'react-i18next';
// import {useTranslation} from 'react-i18next';

// import chekinImageLogoWhite from 'assets/chekin-imago-white.svg';
import {Wrapper, Text} from './styled';

type SplashScreenProps = {
  children: React.ReactNode | JSX.Element;
  visible: boolean;
};

const defaultProps: SplashScreenProps = {
  children: null,
  visible: false,
};

function SplashScreen({children, visible}: SplashScreenProps) {
  const {t} = useTranslation();

  return (
    <>
      <Wrapper visible={visible}>
        <Text>
          <div className="smallText">{t('loading_your')}</div>
          <div className="largeText">{t('reservation_data')}</div>
        </Text>
      </Wrapper>
      {children}
    </>
  );
}

SplashScreen.defaultProps = defaultProps;
export {SplashScreen};
